export {default} from 'views/Adjustments/Adjustments'


// WEBPACK FOOTER //
// ./src/views/Administration/Adjustments.jsx